import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import * as Auth from '../actions/auth.actions';
import * as fromAuth from '../reducers';

@Injectable()
export class AuthGuard implements CanActivate {

  // Constructor
  constructor(private store: Store<fromAuth.State>, private router: Router) {}

  // Can Activate
  canActivate(route: ActivatedRouteSnapshot, stateSnapshot: RouterStateSnapshot): Observable<boolean> {
    // We need to save the path
    const projectRoute = stateSnapshot.url.split('/');
    if (projectRoute[2] === 'project' && projectRoute[3])
      sessionStorage.setItem('csi-session-project', projectRoute[3]);
    return this.store.select(state => state.auth.login)
      .map(authed => {
        if (!authed.token) {
          this.store.dispatch(new Auth.LoginRedirect());
          return false;
        } else {
          sessionStorage.removeItem('csi-session-project');
          if (authed.resetPassword) {
            this.store.dispatch(new Auth.ForcePasswordRedirect());
            return false;
          }
        }
        return true;
      })
      .take(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/services/auth-guard.service.ts